import { CartesianGrid, Line, LineChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';

import './CO2EmissionsBlock.scss';
import { dateFormatDaily } from '../functions';

interface CO2EmissionsBlockProps {
  data: any[];
};

const CO2EmissionsBlock = (props: CO2EmissionsBlockProps) => {
  const displayedData = props.data.map(period => {
    return {
      ...period,
      name: dateFormatDaily(period.name)
    };
  });
  const blockNumber = displayedData ? Math.ceil((displayedData.length + 3) / 16.5) : 0;
  const periodHeadersDisplay = displayedData.map(period => {
    const isDayFormat = (period.name.match(/-/g) || []).length === 2;
    if (isDayFormat) {
      const dateArr = period.name.split('-');
      return dateArr[2] + '/' + dateArr[1];
    }
    return period.name;
  });
  return (
    <div className='split-container-co2'>
      <div className='graph'>
        <ResponsiveContainer width='100%' height={480}>
          <LineChart height={480} data={displayedData} margin={{ right: 40 }}>
            <CartesianGrid strokeDasharray='3 0' vertical={false} />
            <XAxis dataKey='name' minTickGap={10} />
            <YAxis />
            <Line
              name='emissions'
              type='monotone'
              dataKey='value'
              stroke='#00b2b2'
              strokeWidth={2}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className='table' style={{minHeight: blockNumber * 380}}>
        <table>
          <tr>
            <th style={{ width: '10%' }}></th>
            {periodHeadersDisplay.map((item, idx) =>
              <th key={'emissions-header-' + idx} style={{ width: (90 / (displayedData.length + 1)) + '%' }}>{item}</th>
            )}
          </tr>
          <tr>
            <td style={{ width: '10%' }}>CO2 Emissions Generated</td>
            {displayedData.map((item, idx) =>
              <td key={'emissions-values-' + idx} style={{ width: (90 / (displayedData.length + 1)) + '%' }}>{item.value}</td>
            )}
          </tr>
        </table>
        <p>* Emissions data is only available from 01/01/2024</p>
      </div>
    </div>
  );
};

export default CO2EmissionsBlock;